module.exports = __webpack_public_path__ + "static/vegetar-logo-347bb71bc191956a237c54edeb3f122e.png";